import { fork, cancel, take, put } from 'redux-saga/effects'
import splitActionType from 'utils/actions'
import issueTrackerService from 'services/issueTracker/issueTrackerService'

const takeFlow = ({ cancelLastTask = false } = {}) =>
  function* takeEvery(pattern, saga, ...args) {
    const task = yield fork(function* () {
      let lastTask

      // eslint-disable-next-line no-constant-condition
      while (true) {
        const action = yield take(pattern)

        const safeSaga = function* () {
          try {
            yield* saga(action)
          } catch (error) {
            issueTrackerService.captureError(error)
          }
        }

        if (cancelLastTask && lastTask) {
          yield cancel(lastTask) // cancel is no-op if the task has already terminated
        }

        lastTask = yield fork(safeSaga, ...args.concat(action))
      }
    })

    return task
  }

const getRequestPrefix = request => {
  const { type } = request
  if (!type.endsWith('REQUEST')) {
    throw new Error('Can only putAndAwait REQUEST actions!')
  }
  return splitActionType(type).prefix
}

export const takeEvery = takeFlow()

export const takeLatest = takeFlow({ cancelLastTask: true })

export const waitForRequestCompletion = prefix =>
  take([`${prefix}_SUCCESS`, `${prefix}_FAILURE`])

export const putAndAwait = function* (request) {
  const prefix = getRequestPrefix(request)
  yield put(request)
  const result = yield waitForRequestCompletion(prefix)
  if (result.type.endsWith('FAILURE')) {
    throw new Error(`${prefix} failed`)
  }
  return result
}
